module.exports = __webpack_public_path__ + "static/media/about.43984a67.jpg";